import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=15f8121c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f8121c')) {
      api.createRecord('15f8121c', component.options)
    } else {
      api.reload('15f8121c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=15f8121c&", function () {
      api.rerender('15f8121c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KWZhCM6oj2KV/JS/comp/ErrorMessage.vue"
export default component.exports